<template>
<nav class="navbar navbar-expand-md navbar-default bg-default fixed-top">
    <div class="container-fluid">
      <a class="navbar-brand" v-html="html_logo" href="/">
	  </a>

      <!-- need this to cause right align -->
      <!--<ul class="navbar-nav mr-auto"></ul> -->

      <!-- Navbar menu -->

      <ul class="navbar-nav">
        <li class="nav-item" :class="{'active' : menu ==='' }">
          <a class="nav-link" :href="base_site">Appointment</a>
        </li>
		<li class="nav-item" :class="{'active' : menu ==='giftcard' }">
          <a class="nav-link" :href="base_site + 'giftcard'">GiftCard</a>
        </li>
		<li class="nav-item" :class="{'active' : menu ==='aboutus' }">
          <!--<a class="nav-link" @click="goTo('aboutus')">About</a>-->
		  <a class="nav-link" :href="main_site + 'about'">About</a>
        </li>
		<li class="nav-item" :class="{'active' : menu ==='direction' }">
          <!--<a class="nav-link" @click="goTo('direction')">Directions</a> -->
		  <a class="nav-link" :href="main_site + 'contact'">Directions</a>
        </li>
		<li class="nav-item" v-show="!isLogged">
          <a class="nav-link" href="login">Login</a>
        </li>
		<li class="nav-item" v-show="isLogged">
          <a class="nav-link" href="logout">Logout</a>
        </li>
      </ul>

    </div>   <!-- End container -->
</nav>  <!-- End navbar -->
</template>

<script>
	import SpaConstants from '../../../constants';
    export default {
        mounted() {
			this.initNav(); 
        },
		
		props: {

		},

		data () {
			return {

			}
		},
		created () {
		
		},

		computed: {
			isLogged() { 
				return this.$store.state.options.islogged;
			},
			site_name(){
				return SpaConstants.site_name;
			},
			html_logo(){
				return SpaConstants.html_logo;
			},
			menu() {
				return this.$store.state.navigation.menu;
			},
			main_site() {
				return window.main_site_url;
			},
			base_site() {
				return window.base_url;
			}
		},

		watch: {
			
		},
		methods: {
			initNav(){
				if(this.$route.path.indexOf('direction') > 0)
					this.$store.commit('setMenu', 'direction');
				else if(this.$route.path.indexOf('booking') > 0)
					this.$store.commit('setMenu', 'booking');
				else if(this.$route.path.indexOf('giftcard') > 0)
					this.$store.commit('setMenu', 'giftcard');
				else
					this.$store.commit('setMenu', '');
			},
			goTo(url) {
				this.$store.commit('setMenu', url);
				this.$router.push('/' + url);
			}
		},
		components: {
			
		}
    }
</script>

<style>

</style>

